import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as code8OcurrencesActions from 'action/code8occurrences'
import * as reportActions from 'action/report'
import ContentHeader from 'component/utils/ContentHeader'
import OccurrencesCode8 from 'component/report/occurrencescode8/OlderOccurrencesCode8'
import OccurrencesCode8Header from 'component/report/occurrencescode8/OccurrencesCode8Header'
import PeriodPickerOccurrencesCode8 from 'component/report/occurrencescode8/PeriodPickerOccurrencesCode8'
import FeedbackError from 'component/utils/FeedbackError'

const CODE_8_REPORT_CODE = 16

class OlderOccurrencesCode8Container extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    fetchCode8Occurrences: PropTypes.func.isRequired,
    fetchCode8OccurrencesSuccess: PropTypes.func.isRequired,
    fetchReports: PropTypes.func.isRequired,
    fetchAsyncReports: PropTypes.func.isRequired,
    error: PropTypes.object,
    code8Occurrences: PropTypes.object,
    filters: PropTypes.object,
    auth: PropTypes.object.isRequired,
    reportError: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.state = {
      filtersVisible: true,
      code8OccurrencesInfoVisible: false,
      controlView: false,
    }

    this.invertStates = this.invertStates.bind(this)
    this.handleFetchCode8Occurrences =
      this.handleFetchCode8Occurrences.bind(this)
  }

  componentWillReceiveProps() {
    const { filtersVisible, controlView } = this.state
    const { code8Occurrences } = this.props

    /* istanbul ignore else */
    if (filtersVisible && code8Occurrences && controlView) {
      this.invertStates()
    }
  }

  invertStates() {
    let { filtersVisible, code8OccurrencesInfoVisible } = this.state

    filtersVisible = !filtersVisible
    code8OccurrencesInfoVisible = !code8OccurrencesInfoVisible

    this.setState({ filtersVisible })
    this.setState({ code8OccurrencesInfoVisible })
  }

  handleFetchCode8Occurrences(values) {
    
    const {
      auth: {
        user: { dsToken, locationCode },
      },
      fetchAsyncReports,
      fetchCode8OccurrencesSuccess,
    } = this.props

    this.setState({ controlView: true })

    const filters = {
      ...values,
      idBranch: locationCode.padStart(4, 0),
    }

    fetchAsyncReports(
      dsToken,
      { tpReport: CODE_8_REPORT_CODE },
      filters,
      fetchCode8OccurrencesSuccess
    )
  }

  getCsv = () => {
    const {
      fetchAsyncReports,
      filters,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 6,
    }

    fetchAsyncReports(user.dsToken, values, filters)
  }

  getCsvRecurrence = () => {
    const {
      fetchReports,
      filters,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 7,
    }

    fetchReports(user.dsToken, values, filters)
  }

  renderError(message) {
    /* istanbul ignore else */
    if (message.dsMessage) {
      return (
        <FeedbackError
          className='margin-top-double margin-left'
          message={message.dsMessage}
        />
      )
    }
  }

  render() {
    const { translate, error, code8Occurrences, filters, auth, reportError } =
      this.props

    const { filtersVisible, code8OccurrencesInfoVisible } = this.state

    return (
      <section>
        <ContentHeader>
          {translate('mobile.olderOccurrences-code8')}
        </ContentHeader>

        <OccurrencesCode8Header
          translate={translate}
          pageName={translate('mobile.olderOccurrences-code8')}
        />

        {error && !filtersVisible && this.renderError(error.message)}
        {reportError && this.renderError(reportError.message)}

        {filtersVisible && (
          <PeriodPickerOccurrencesCode8
            translate={translate}
            fetchCode8Occurrences={this.handleFetchCode8Occurrences}
            auth={auth}
          />
        )}

        {code8OccurrencesInfoVisible && (
          <OccurrencesCode8
            translate={translate}
            code8Occurrences={code8Occurrences}
            filters={filters}
            getCsv={this.getCsv}
            getCsvRecurrence={this.getCsvRecurrence}
          />
        )}
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
const mapStateToProps = (
  { code8OccurrencesReducer, reportReducer },
) => ({
  code8Occurrences: code8OccurrencesReducer.record,
  error: code8OccurrencesReducer.error,
  filters: code8OccurrencesReducer.filters,
  report: reportReducer.get.record,
  reportError: reportReducer.get.error,
})

/*
 * Maps actions and dispatch them to component props
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...code8OcurrencesActions, ...reportActions }, dispatch)

/*
 * Connects component to I18next
 */
const OccurrencesCode8Translated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(OlderOccurrencesCode8Container)

/*
 * Exports component connected to redux as default
 */
const OccurrencesCode8TranslatedConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(OccurrencesCode8Translated)

export default OccurrencesCode8TranslatedConnect

/*
 * Exports as component
 */
export { OlderOccurrencesCode8Container }
